<template>
  <div class="w-full h-full flex flex-col bg-primary-700">
    <div class="px-4 w-full z-20 bg-primary-700">
      <router-link :to="{name:'userManagement'}" class="w-full flex items-center h-13 hov-arrow-back border-b border-solid border-primary-500">
        <i class="bg-secondary h-6 w-6 flex items-center justify-center rounded transition-200">
          <span class="icon-left text-white text-xs inline-block rounded"></span>
        </i>
        <p class="truncate text-xl sm:text-2xl md:text-3xl font-ligt pl-4">{{name}}</p>
      </router-link>
    </div>
    <div class="w-full h-16 bg-primary-700 flex sticky top-0 xl:hidden z-20 overflow-hidden">
      <!-- <div class="active-tab-bg h-16 bg-primary-900 w-1/2 absolute inline-block z-0" /> -->
      <div @click="activeTab = true" :class="{'clickable-tab':!activeTab}" class="text-light w-1/2 flex justify-center items-center inline-block z-10">
        Datos del usuario
      </div>
      <div @click="activeTab = false" :class="{'clickable-tab':activeTab}" class="text-light w-1/2 flex justify-center items-center inline-block z-10">
        Rol
      </div>
    </div>
    <div @click="isModified = true" class="h-full flex relative">
      <!-- DATOS -->
      <div :class="{'hidden':!activeTab, 'pb-12': isModified }"  class="transition-200 bg-primary-700 xl:inline-block w-full h-full overflow-auto">
        <div class="px-2 py-4">
          <div class="bg-primary-800 mx-2 mb-4 px-2 py-2 rounded-lg">
            <div class="px-2 pb-2 hidden xl:inline-block">
              <p class="text-lg sm:text-xl md:text-2xl text-light">Datos del usuario</p>
            </div>
             <div class="flex flex-wrap">
              <div class="flex flex-col pb-4 px-2 w-full sm:w-2/3">
                <label for="name" class="text-primary-200 text-sm pb-2">Nombre</label>
                <Input @focus="removeName" @blur="addName" id="name" v-model="name" placeholder="Nombre del usuario…"/>
              </div>
              <div class="flex flex-col pb-4 px-2 w-full sm:w-1/3">
                <label for="tlf" class="text-primary-200 text-sm pb-2">Teléfono</label>
                <Input id="tlf" v-model="tlf" placeholder="Teléfono de contacto…"/>
              </div>
            </div>
            <div class="flex flex-col pb-4 px-2">
              <label for="email" class="text-primary-200 text-sm pb-2">Email</label>
              <Input id="email" v-model="email" placeholder="Email de contacto…"/>
            </div>
            <div class="flex flex-col pb-4 px-2 w-full">
              <label for="company" class="text-primary-200 text-sm pb-2">Empresa</label>
              <Select id="company" v-model="company" placeholder="Seleccine empresa…">
                <Option
                  v-for="item in billTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </Option>
              </Select>
            </div>
          </div>
          <Collapse>
            <Collapse-item title="Aprobación" name="approval">
              <div class="flex items-center px-2 overflow-auto" :class="{'pointer-events-none , opacity-25':addApprovalOpened}">
                <Table
                  ref="multipleTable"
                  :data="approvalData"
                  style="width: 100%; min-width:500px"
                  @selection-change="handleSelectionChange">
                  <TableColumn
                    type="selection"
                    width="55">
                  </TableColumn>
                  <TableColumn
                    sortable
                    property="company"
                    label="Empresa">
                  </TableColumn>
                  <TableColumn
                    sortable
                    property="location"
                    label="Sede">
                  </TableColumn>
                  <TableColumn
                    sortable
                    property="center"
                    width="160"
                    label="Centro de coste">
                  </TableColumn>
                  <TableColumn
                    fixed="right"
                    sortable
                    property="level"
                    width="65"
                    label="Nv">
                  </TableColumn>
                </Table>
              </div>
              <div class="flex flex-wrap xl:flex-no-wrap items-end z-50">
                <transition name="modal-fade-down">
                  <div v-if="addApprovalOpened" class="flex flex-col px-2 pt-4 w-full sm:w-1/2 lg:w-4/12">
                    <Input id="newApprovalCompany" v-model="newApprovalCompany" placeholder="Empresa…"/>
                  </div>
                </transition>
                <transition name="modal-fade-down">
                  <div v-if="addApprovalOpened" class="flex flex-col px-2 pt-4 w-full sm:w-1/2 lg:w-4/12">
                    <Input id="newApprovalLocation" v-model="newApprovalLocation" placeholder="Sede…"/>
                  </div>
                </transition>
                <transition name="modal-fade-down">
                  <div v-if="addApprovalOpened" class="flex flex-col px-2 pt-4 w-full sm:w-1/2 lg:w-3/12">
                    <Input id="newApprovalCenter" v-model="newApprovalCenter" placeholder="Centro de coste…"/>
                  </div>
                </transition>
                <transition name="modal-fade-down">
                  <div v-if="addApprovalOpened" class="flex flex-col px-2 pt-4 w-full xl:min-w-16 sm:w-1/2 lg:w-1/12">
                    <Input id="newApprovalLevel" v-model="newApprovalLevel" placeholder="Nivel…"/>
                  </div>
                </transition>
              </div>
              <div class="flex flex-wrap xl:flex-no-wrap items-end z-50">
                <div class="w-full md:w-auto pt-4 px-2 ml-auto flex">
                  <Button v-if="!ApprovalSelected" @click="addApproval()" class="w-full truncate" type="primary" icon="el-icon-plus">Añadir <span v-if="!addApprovalOpened">aprobación</span></Button>
                  <Button v-if="!ApprovalSelected && addApprovalOpened" @click="addApproval()" class="w-full truncate" type="info" icon="el-icon-close">cancelar</Button>
                  <Button v-if="ApprovalSelected" @click="removeApproval()" class="w-full truncate" type="danger" icon="el-icon-delete">Eliminar</Button>
                </div>
              </div>
            </Collapse-item>
          </Collapse>
        </div>
      </div>
      <!-- END DATOS -->
      <!-- ROL -->
      <div :class="{'hidden':activeTab}" class="w-full xl:inline-block relative xl:bg-primary-900 xl:max-w-2xl">
        <div class="px-2 relative h-auto" style="max-height:calc(100vh - 125px)">
          <div class="px-2 pt-4 hidden xl:inline-block">
            <p class="text-lg sm:text-xl md:text-2xl text-light">Rol</p>
          </div>
          <div class="flex justify-between sticky top-0 h-16 mt-4">
            <div @click="activeAdmin = true, activeAccount = false, activeQueries = false" class="cursor-pointer transition-200 flex items-center justify-center w-1/3 pb-2 -mb-2 rounded-t-lg " :class="[activeAdmin === true ? 'bg-primary-800':'text-secondary']">
              <span class="px-2">Administrador</span>
              <span class="bubble-c08">2</span>
            </div>
            <div @click="activeAdmin = false, activeAccount = true, activeQueries = false" class="cursor-pointer transition-200 flex items-center justify-center w-1/3 pb-2 -mb-2 rounded-t-lg" :class="[activeAccount === true ? 'bg-primary-800':'text-secondary']">
              <span>Contabilidad</span>
            </div>
            <div @click="activeAdmin = false, activeAccount = false, activeQueries = true" class="cursor-pointer transition-200 flex items-center justify-center w-1/3 pb-2 -mb-2 rounded-t-lg" :class="[activeQueries === true ? 'bg-primary-800':'text-secondary']">
              <span>Consultas</span>
            </div>
          </div>
          <div class="px-2 py-4 bg-primary-800 rounded-lg overflow-y-auto h-full" style="max-height:calc(100% - 165px)">
            <div class="mx-2 px-2 rounded-lg">
              <div class="pb-2 hidden xl:inline-block">
                <p class="text-lg sm:text-xl md:text-2xl text-light">Acceso a empresas</p>
              </div>
              <div class="flex justify-between">
                <div  v-if="activeAdmin" class="flex flex-wrap pb-4">
                  <label v-for="empresa in empresas" :key="empresa" class="toggle-token relative cursor-pointer inline-block flex items-center m-2">
                    <input :id='empresa' :v-model="empresa" type="checkbox" class="opacity-0 h-0 w-0">
                    <span class="h-10 rounded-l-full rounded-r-full flex items-center px-4 uppercase bg-primary-600 text-xs">{{empresa}}</span>
                  </label>
                  <!-- <div v-for="empresa in empresas" :key="empresa" class="w-1/2 py-1 flex">
                    <Checkbox :id='empresa' :v-model="empresa">{{empresa}}</Checkbox>
                  </div> -->
                  <!-- Dejo esto comentado por si no les encajan este tipo de checkbox, sería necesario añadir como componente el Checkbox de Element -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--END ROL -->
    </div>
    <div class="w-full absolute bottom-0 right-0 overflow-hidden transition-200 flex items-center px-4 global bg-primary-800" :class="[isModified ? 'h-12':'h-0']" style="z-index:1">
      <div class="ml-auto">
        <Button @click="isModified = !isModified" type="primary" size="small" icon="el-icon-check"><span class="hidden sm:inline-block">Guardar cambios</span></Button>
      </div>
    </div>
  </div>
</template>
<script>
import { Input, Select, Option, Button, Table, TableColumn, CollapseItem, Collapse } from 'element-ui'
export default {
  components: {
    Table,
    TableColumn,
    CollapseItem,
    Collapse,
    Select,
    Option,
    Button,
    Input
  },
  data () {
    return {
      url: 'https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK',
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      billTypes: [{
        value: 'ASIENTOS CONTABLES (suministros, arrendamientos, servicio externo, Compras)',
        label: 'ASIENTOS CONTABLES (suministros, arrendamientos, servicio externo, Compras)'
      }, {
        value: 'Lo que sea CONTABLES (suministros, arrendamientos, servicio externo, Compras)',
        label: 'Lo que sea CONTABLES (suministros, arrendamientos, servicio externo, Compras)'
      }, {
        value: 'ASIENTOS Lorem ipsum (suministros, arrendamientos, servicio externo, Compras)',
        label: 'ASIENTOS Lorem ipsum (suministros, arrendamientos, servicio externo, Compras)'
      }, {
        value: 'ASIENTOS CONTABLES (A lot of things)',
        label: 'ASIENTOS CONTABLES (A lot of things)'
      }, {
        value: 'ASIENTOS Lorem ipsum dolor sit amet consectetur adipiscing elit',
        label: 'ASIENTOS Lorem ipsum dolor sit amet consectetur adipiscing elit'
      }, {
        value: 'Imaginarias',
        label: 'Imaginarias'
      }],
      approvalData: [{
        company: 'María Cepeda',
        location: 'CTO',
        center: 'mcepeda@bibendum.com',
        level: '3'
      }, {
        company: 'Richard Tomás',
        location: 'Contabilidad',
        center: 'rtomas@dolimse.com',
        level: '2'
      }],
      newApprovalCompany: '',
      newApprovalLocation: '',
      newApprovalCenter: '',
      newApprovalLevel: '',

      name: 'Nuevo usuario',
      tlf: '',
      email: '',
      company: '',
      activeTab: true,
      activeAdmin: true,
      activeAccount: false,
      activeQueries: false,
      isModified: false,
      addApprovalOpened: false,
      ApprovalSelected: false,
      rol: 'administrador',
      empresas: ['empresa01', 'empresa02', 'empresa03', 'empresa04', 'empresa05', 'empresa06', 'empresa07', 'empresa08', 'empresa09', 'empresa10', 'empresa11', 'empresa12', 'empresa13', 'empresa14', 'empresa15', 'empresa16'
      ]
    }
  },

  methods: {
    urlUpdated (url) {
      this.documentError = undefined
      this.url = url
    },
    onDocumentErrored (e) {
      this.documentError = e.text
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    removeName () {
      if (this.name === 'Nuevo usuario' || this.name === 'Nombre del usuario') {
        this.name = ''
      }
    },
    addApproval () {
      this.addApprovalOpened = !this.addApprovalOpened
    },
    addName () {
      if (this.name === '') {
        this.name = 'Nombre del usuario'
      }
    }
  }
}
</script>
